// COLLEGE CONFERENCE RENAME (ISSUE-1387, QA COLLEGE-CONF-NAMES). The ingest
// renamed some college conferences to their official names, which changed
// their group keys (pacific-12 became pac-12, and so on). A fan's
// ?conference= link may carry either generation, and the league's
// conference list answers with whichever generation the last standings pull
// stored. The API already reads an old and a new key as one conference; this
// lets the web pane do the same when it matches the URL key to the list.
//
// Keep this table in step with LEGACY_CONFERENCE_KEY_ALIASES in
// services/sports-api/src/lib/leagueConferences.ts (old key -> new key). No
// package is shared by the web app and sports-api other than the generated
// SDK, so the table is copied here.
export const CONFERENCE_KEY_ALIASES: Readonly<Record<string, string>> = {
  "mid-american-east": "mid-eastern-athletic",
  "atlantic-sun": "asun",
  "colonial-athletic": "coastal-athletic",
  "colonial-athletic-association": "coastal-athletic",
  "pacific-12": "pac-12",
  american: "american-conference",
  "american-athletic": "american-conference",
  uac: "united-athletic",
};

/** PURE. The current key for an old or a current conference key. */
export function canonicalConferenceKey(conferenceKey: string): string {
  return CONFERENCE_KEY_ALIASES[conferenceKey] ?? conferenceKey;
}

/** PURE. The key of the listed conference a requested key names, old and new
 *  keys alike, or null when the list names no such conference. An exact
 *  match wins over an alias match. */
export function resolveListedConferenceKey(input: {
  requestedKey: string;
  listedKeys: readonly string[];
}): string | null {
  if (input.listedKeys.includes(input.requestedKey)) return input.requestedKey;
  const wanted = canonicalConferenceKey(input.requestedKey);
  return (
    input.listedKeys.find((key) => canonicalConferenceKey(key) === wanted) ??
    null
  );
}
